const bom = {
    bomType: "Bom 유형",
    bomCode: '마스터 코드',
    bomName: '마스터 파트 이름',
    bomModal: '재료 사양',
    bomUnit: '측정 단위',
    bomVersion: '버전 번호',
    bomVersionDesc: '버전 설명',
    bomVersionDate: '버전 날짜',
    bomStatus: 'Bom 상태',
    approveder: '승인자',
    createDate: '파일 생성 날짜',
    creator: '파일 생성자',
    updateDate: '수정 날짜',
    updater: '수정자',

    itemLevel: '레벨',
    itemCode: '아이템 코드',
    itemName: '하위 항목 이름',
    itemModal: '하위 항목 사양',
    itemUnit: '측정 단위',
    itemBase: '기본 수량',
    itemBaseQuantity: '기본 수량',
    itemAttritionRate: '하위 항목 손실률',
    itemUseQuantity: '수량 사용',
    itemEffectiveDate: '유효 날짜',
    itemExpiringDate: '만료일',
    itemReMark: '비고',
    itemLocators: '위치 1',
    itemExtraRate: '재고율',

    itemLevelInfo: '레벨 {{ level }}',
    itemReq: '대체 재료',

    plBaseUnit: '기본 수량을 입력하세요',
    plBaseQuantity: '기본 수량을 입력하세요',
    plAttritionRate: '구성요소 손실률을 입력하세요',
    plUseQuantity: '사용량을 입력해주세요',
    plRemark: '비고사항을 입력해주세요',
    plLocators: '로케이터 1을 입력하세요',

    importError: '가져오기 실패',
    bomUpload: 'BOM 가져오기',
    bomDetail: 'BOM 세부 정보',
    closeTip: "요구사항 목록이 아직 생성되지 않았습니다. 닫으시겠습니까?",
    errTip: "데이터 확인 바랍니다",
    errTipdesc: "최소 하나의 자재 요청 수량이 0보다 커야 계속할 수 있습니다",
    stockNum: "재고 수량",
    reqManage: "수요 목록 관리",
    preStock: "예상 출고 재고 수량",
    preInStock: "예상 입고 재고 수량",
    useStock: "사용 가능 재고 수량",
    prePurNum: "구매 필요 수량 (상비품은 0)",
    prePurNum_1: "구매 필요 수량",
    preOutNum: "예상 출고 수량 (상비품은 예상 출고 안 함)",
    preOutNum_1: "예상 출고 수량",
    matchErr: "재고 매칭 실패",
    noSaleOrderOrProduct: "수요 목록에 상위 품목이 없어 생산 수량 출고를 진행할 수 없습니다",
    bomUsageMatchErr: "BOM 매칭에 실패하여 생산 수량 출고를 진행할 수 없습니다",
    confirmAdd: "수요 목록 추가 (예상 출고서)",
    inventorySucc: "예상 출고서: {{number}}가 생성되었습니다. 출고 위치가 할당되었습니다",
    saveTemp: "템플릿을 저장하시겠습니까?",
    merge: "자재: {{codes}} 중복됨, 해당 필요 수량이 합산되었습니다",
    editBom: "BOM 표 편집",
    addBom: "BOM 표 추가",
    materialControlTemplate: "자재 관리 요구사항 템플릿",
    originBom: "주자재",
    calcErr: "혼합 자재 수량 할당 오류!",
    calcData: "조건: 주자재 필요 수량 + 모든 대체자재 필요 수량의 합 = 주자재의 총 표준 수량",
    allocated: "사용된 재고량",
    expandAll: "모두 펼치기",
    collapseAll: "모두 접기",
    parseBonErr: "BOM 파싱 실패",
    addTip: "다음 자재가 시스템에 없습니다. 추가하시겠습니까?",
    notItem: "다음 자재가 시스템에 없어 수요 주문 데이터가 생성되지 않습니다",
    fileErr: "BOM 첨부 파일 정보 조회 실패",
    facStock: "생산라인 재고",
    facStockAlloc: "사용된 생산라인 재고",
    useFactoryCount: "생산라인 재고 사용량",
    realStockNum: "보유 재고 수량",
    realPreStock: "보유 재고 사전 출고 수량",
    realUseStock: "사용 가능 보유 재고 수량",
    realAllocated: "사용된 보유 재고 수량",
    bomNull: "사용 가능한 BOM 데이터 소스가 없습니다",
    bomNullTip: "판매 주문 BOM 파일, 템플릿, 시스템 BOM 데이터 중 최소 하나는 있어야 합니다",
};

export default bom;
